import React from "react"

const Footer = () => {
  return (
    <>
      <footer>
        <div className='conatiner text-center top'>
          <p>© 2022. All rights created by Ibrahim Serhane.</p>
        </div>
      </footer>
    </>
  )
}

export default Footer
